import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
import getters from './getters'

Vue.use(Vuex)

const state = {
	userInfo: null, //用户信息
  searchKey: '',//首页，列表，分类页搜索
  cartList: 0,//购物车商品
  categoryType: -1,//分品分类
  activeCity: '杭州', //当前杭州
  activeCityOnce: true, //只加载一次
  showLoading: true, //默认显示加载动画
  loginState: '',//用户登录状态
  wxLoginUrl: '',//微信授权登录URL
  activeAddress:null,//收货地址
  showAlert:false,
  alertMessage:'提示',
  orderList: [],//订单列表

  position:{},//之前页面位置
  arrPageName:'index',//当前页面NAME

  platform:'h5',//平台
  appVersion:1,

  acitiveLocalNo:'',//当前地址编号
  acitiveLocal:'',//当前地址信息
  isBack:false,







}

export default new Vuex.Store({
	state,
	getters,
	actions,
	mutations,
})



// WEBPACK FOOTER //
// ./src/story/index.js